import { render, staticRenderFns } from "./editRewardRainCampaign.vue?vue&type=template&id=72a72a60&lang=pug"
import script from "./editRewardRainCampaign.vue?vue&type=script&lang=js"
export * from "./editRewardRainCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports